/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAllowedDocument } from './PaxCheckAllowedDocument';
import {
    PaxCheckAllowedDocumentFromJSON,
    PaxCheckAllowedDocumentFromJSONTyped,
    PaxCheckAllowedDocumentToJSON,
    PaxCheckAllowedDocumentToJSONTyped,
} from './PaxCheckAllowedDocument';

/**
 * A set of documents with which this checklist item can be resolved
 * @export
 * @interface PaxCheckAllowedDocumentsSet
 */
export interface PaxCheckAllowedDocumentsSet {
    /**
     * When true, it is required to provide exactly 1 value for `expected_document_types` when calling apply-document/file endpoint - ie user must choose document type they are uploading
     * @type {boolean}
     * @memberof PaxCheckAllowedDocumentsSet
     */
    forceDocumentTypeRequired: boolean;
    /**
     * List of documents that can resolve a checklist item
     * @type {Array<PaxCheckAllowedDocument>}
     * @memberof PaxCheckAllowedDocumentsSet
     */
    allowedDocuments: Array<PaxCheckAllowedDocument>;
}

/**
 * Check if a given object implements the PaxCheckAllowedDocumentsSet interface.
 */
export function instanceOfPaxCheckAllowedDocumentsSet(value: object): value is PaxCheckAllowedDocumentsSet {
    if (!('forceDocumentTypeRequired' in value) || value['forceDocumentTypeRequired'] === undefined) return false;
    if (!('allowedDocuments' in value) || value['allowedDocuments'] === undefined) return false;
    return true;
}

export function PaxCheckAllowedDocumentsSetFromJSON(json: any): PaxCheckAllowedDocumentsSet {
    return PaxCheckAllowedDocumentsSetFromJSONTyped(json, false);
}

export function PaxCheckAllowedDocumentsSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAllowedDocumentsSet {
    if (json == null) {
        return json;
    }
    return {
        
        'forceDocumentTypeRequired': json['force_document_type_required'],
        'allowedDocuments': ((json['allowed_documents'] as Array<any>).map(PaxCheckAllowedDocumentFromJSON)),
    };
}

export function PaxCheckAllowedDocumentsSetToJSON(json: any): PaxCheckAllowedDocumentsSet {
    return PaxCheckAllowedDocumentsSetToJSONTyped(json, false);
}

export function PaxCheckAllowedDocumentsSetToJSONTyped(value?: PaxCheckAllowedDocumentsSet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'force_document_type_required': value['forceDocumentTypeRequired'],
        'allowed_documents': ((value['allowedDocuments'] as Array<any>).map(PaxCheckAllowedDocumentToJSON)),
    };
}

